module.exports = __webpack_public_path__ + "static/img/linea-etica.a90051c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gobierno/linea-etica.jpg
// module id = KMsP
// module chunks = 0